import React, { useContext } from 'react'
import { useField } from 'formik'

import { Switch, styled, SwitchProps } from 'tamagui'

import { FormFieldContext } from './shared'

export const FormSwitch = (props: SwitchProps) => {
  const formFieldContext = useContext(FormFieldContext)
  const [field, _meta, helpers] = useField(formFieldContext.name)
  const isChecked = !!field.value

  return (
    <StyledSwitch
      {...props}
      animation='fastSpring'
      size='$11'
      checked={isChecked}
      backgroundColor={isChecked ? '$primaryColor' : '$borderColor'}
      onCheckedChange={(checked: boolean) => {
        helpers.setValue(checked)

        if (props.onCheckedChange) {
          props.onCheckedChange(checked)
        }
      }}
    >
      <StyledSwitchThumb size='$9' animation='fastSpring' />
    </StyledSwitch>
  )
}

const StyledSwitch = styled(Switch, {
  acceptsClassName: true,

  padding: 3,

  // outlineStyle: 'unset',
  outlineColor: '$backgroundAccentMuted',
} as const)

const StyledSwitchThumb = styled(Switch.Thumb, {
  //   margin: 4,

  backgroundColor: '$background',
  // @ts-expect-error boxShadow is web-only
  boxShadow: `rgba(10, 37, 64, 0.24) 0px 2px 6px`,
} as const)
